/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Options } from 'src/app/shared/models/options';
import { createReducer, on } from '@ngrx/store';
import {
  setGoBack,
  flagLoadScript,
  setToken,
  setDeeplink,
  setCustomerId,
  setCustomerBirthDate,
  setOptions,
  setShowError,
  setVersionApp,
  setOperatingSystem,
  setGlobalId,
  setCdaJourney,
} from './contactscreen.actions';
export interface IContactScreen {
  globalId: string;
  showError: boolean;
  goBack: string;
  flagLoadScript: boolean;
  token: string;
  deeplink: string;
  customerId: string;
  customerBirthDate: string;
  versionApp: string;
  operatingSystem: string;
  menu: Options;
  cdaJourney: string;
}

export const initialState: IContactScreen = {
  showError: false,
  goBack: '',
  flagLoadScript: false,
  token: '',
  deeplink: '',
  customerId: '',
  customerBirthDate: '',
  versionApp: '',
  operatingSystem: '',
  menu: {
    options: [],
  },
  globalId: '',
  cdaJourney: '',
};
const _contactscreenReducer = createReducer(
  initialState,
  on(setShowError, (state, { payload }) => ({
    ...state,
    showError: payload,
  })),
  on(setGoBack, (state, { payload }) => ({
    ...state,
    goBack: payload,
  })),
  on(flagLoadScript, (state, { payload }) => ({
    ...state,
    flagLoadScript: payload,
  })),
  on(setToken, (state, { payload }) => ({
    ...state,
    token: payload,
  })),
  on(setDeeplink, (state, { payload }) => ({
    ...state,
    deeplink: payload,
  })),
  on(setCustomerId, (state, { payload }) => ({
    ...state,
    customerId: payload,
  })),
  on(setCustomerBirthDate, (state, { payload }) => ({
    ...state,
    customerBirthDate: payload,
  })),
  on(setVersionApp, (state, { payload }) => ({
    ...state,
    versionApp: payload,
  })),
  on(setOperatingSystem, (state, { payload }) => ({
    ...state,
    operatingSystem: payload,
  })),
  on(setOptions, (state, { payload }) => ({
    ...state,
    menu: payload,
  })),
  on(setGlobalId, (state, { payload }) => ({
    ...state,
    globalId: payload,
  })),
  on(setCdaJourney, (state, { payload }) => ({
    ...state,
    cdaJourney: payload,
  })),
);

export function contactscreenReducer(state: any, action: any) {
  return _contactscreenReducer(state, action);
}
